var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.getHeight)},[(_vm.showMap)?_c('l-map',{ref:"myMap",attrs:{"options":_vm.mapOptions}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-geo-json',{attrs:{"geojson":_vm.geojson,"options":_vm.geoOptions}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }